import SystemModal from "../Common/SystemModal";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelPumps from "../../util/remote/ajaxFuelPumps";
import AuthContext from "../../Context/AuthContext";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxFuelPrices from "../../util/remote/ajaxFuelPrices";
const UpdateStationModal = (props) => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [stationID, setStationID] = useState("");
  const [fuelCategoryID, setFuelCategoryID] = useState(null);
  const [sellingPrice, setSellingPrice] = useState("");
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [date, setDate] = useState(getCurrentDate());
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      const data = props.data;
      setStationID(data.station_id);
      setFuelCategoryID(data.fuel_id);
      setSellingPrice(data.selling_price);
    }
  }, [props.data]);
  // Fetch stations
  const [stationsList, setStationsList] = useState([]);
  const fetchStations = async () => {
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      setStationsList(
        Array.isArray(response.details) &&
          response.details.map((d) => ({ value: d.id, label: d.station_name }))
      );
    } else {
      toast.error(response.message);
    }
  };
  // Fetch fuel categories
  const [fuelCategoriesList, setFuelCategoriesList] = useState([]);
  const fetchFuelCategories = async () => {
    const response = await ajaxFuelCategories.list_fuel_categories({
      station_id: stationID,
    });
    if (response.status === "OK") {
      setFuelCategoriesList(
        Array.isArray(response.details) &&
          response.details.map((d) => ({ value: d.id, label: d.fuel_category }))
      );
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    fetchStations();
  }, []);
  useEffect(() => {
    fetchFuelCategories();
  }, [stationID]);
  // Validation
  const allRowsFilled = () => stationID;
  // Update handler
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      station_id: stationID,
      fuel_id: fuelCategoryID,
      selling_price: sellingPrice,
      date: date,
      adjusted_by_id: userId,
    };
    setLoading(true);
    const response = await ajaxFuelPrices.update_Prices(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func(); // refresh parent data
      setTimeout(() => closeModal(), 2000);
    } else {
      toast.error(response.message);
    }
  };
  // Footer buttons
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading || !allRowsFilled()}
      >
        {loading ? "Updating..." : "Update"}
      </button>
    </>
  );
  return (
    <SystemModal title="Update station" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card custom-card"
                style={{ borderRadius: "10px" }}
              >
                <div className="card-body">
                  <h6 className="card-title mb-4"></h6>
                  <form>
                    <div className="row mb-3">
                      {/* Station */}
                      <div className="col-md-12 mb-3">
                        <label>
                          Select Station <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          options={stationsList}
                          value={stationsList.find(
                            (s) => s.value === stationID
                          )}
                          onChange={(selected) => setStationID(selected.value)}
                          placeholder="Select station"
                        />
                      </div>
                      {/* Fuel Category */}
                      <div className="col-md-12 mb-3">
                        <label>
                          Fuel Category <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          options={fuelCategoriesList}
                          value={fuelCategoriesList.find(
                            (c) => c.value === fuelCategoryID
                          )}
                          onChange={(selected) =>
                            setFuelCategoryID(selected.value)
                          }
                          placeholder="Select fuel category"
                        />
                      </div>
                      {/* Selling Price */}
                      <div className="col-md-12 mb-3">
                        <label>
                          Selling Price <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          value={sellingPrice}
                          onChange={(e) => setSellingPrice(e.target.value)}
                          className="form-control"
                          placeholder="Enter selling price"
                          required
                        />
                      </div>
                      {/* Date */}
                      <div className="col-md-12 mb-3">
                        <label>
                          Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </SystemModal>
  );
};
export default UpdateStationModal;
